module.exports = __webpack_public_path__ + "static/media/SBTconcept22.a49123d1.jpg";